export var RowsError;
(function (RowsError) {
})(RowsError || (RowsError = {}));
var RowsRequest = /** @class */ (function () {
    function RowsRequest(id, query, custom) {
        this.knownErrorCodes = Object.values(RowsError);
        this.path = "".concat(custom ? 'my/customized-' : '', "reports/").concat(encodeURIComponent(id), "/rows?").concat(String(query.searchParams));
    }
    return RowsRequest;
}());
export { RowsRequest };
